import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Check } from 'lucide-react';
export function Garantia() {
  const badges = [{
    icon: Lock,
    text: 'Compra Segura'
  }, {
    icon: Check,
    text: 'Satisfacción Garantizada'
  }, {
    icon: ShieldCheck,
    text: 'Privacidad Protegida'
  }];
  return <section id="garantia" className="py-[100px] bg-gradient-to-b from-[#1a0f08] to-[#120806]" data-id="element-187">
      <div className="container-custom" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        type: 'spring',
        bounce: 0.3
      }} className="max-w-[700px] mx-auto bg-gradient-to-br from-green-soft/10 to-green-soft/5 border border-green-soft/20 rounded-[16px] p-[60px_48px] text-center max-sm:p-[40px_24px]" data-id="element-189">
          <motion.div className="w-[140px] h-[140px] mx-auto mb-6 animate-pulse-scale" initial={{
          opacity: 0,
          rotateY: 90
        }} whileInView={{
          opacity: 1,
          rotateY: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-190">
            <img src="https://i.postimg.cc/8zMRv1fQ/selo-garantia-png-2.webp" alt="Garantía de 7 días" className="w-full h-full object-contain drop-shadow-[0_4px_20px_rgba(111,204,160,0.3)]" data-id="element-191" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4,
          type: 'spring',
          bounce: 0.5
        }} className="font-display text-[64px] font-black text-[#6fcca0] leading-none mb-1" data-id="element-192">
            7
          </motion.div>
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="text-[13px] tracking-[2px] uppercase text-[#6fcca0] mb-6 block font-semibold" data-id="element-193">
            Días de garantía total
          </motion.span>

          <motion.h3 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} className="font-display text-[24px] text-white mb-4 font-bold" data-id="element-194">
            O te devolvemos el dinero. Sin preguntas.
          </motion.h3>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.7,
          duration: 0.6
        }} className="text-[15px] text-gray leading-[1.7] max-w-[480px] mx-auto" data-id="element-195">
            Si en los primeros 7 días sentís que el Protocolo de Reprogramación
            Digestiva™ no es lo que esperabas, te devolvemos el 100% de tu
            inversión. Sin formularios complicados. Sin justificaciones.
            <br data-id="element-196" />
            <br data-id="element-197" />
            Te ofrezco esta garantía porque confío en que lo que hay dentro
            funciona. El riesgo es mío, no tuyo.
          </motion.p>

          <div className="flex justify-center gap-8 mt-8 flex-wrap" data-id="element-198">
            {badges.map((badge, i) => <motion.span key={i} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.8 + i * 0.15
          }} className="flex items-center gap-1.5 text-[12px] text-[#6fcca0]" data-id="element-199">
                <badge.icon className="w-3.5 h-3.5" data-id="element-200" /> {badge.text}
              </motion.span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}